let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cLqdU")).then(() => parcelRequire('5uIs5'));